import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  dateTimePicker: {
    '& .MuiMenuItem-root': {
      color: '#2C2D3E',
      padding: '2px 0px 2px 15px',
      fontSize: '13px',
      '&:hover, &:focus': {
        backgroundColor: 'white',
        color: '#3C419A',
      },
    },
    '& .MuiTextField-root': {
      width: '180px',
      padding: '2px',
    },
    '& .MuiPickersStaticWrapper-staticWrapperRoot': {
      flexDirection: 'unset',
      justifyContent: 'center',
    },
    '& .MuiPickersCalendarHeader-switchHeader': {
      display: 'flex',
      flexDirection: 'row',
      '& .MuiPickersCalendarHeader-transitionContainer': {
        order: '-1',
      },
    },
    '& .MuiPickersDay-hidden': {
      opacity: '0.2',
    },
    '& .MuiPickersDay-dayDisabled': {
      color: 'rgba(0, 0, 0, 0.5)',
    },
    '& .MuiPickersDay-daySelected': {
      backgroundColor: '#3C419A',
    },
    '& .dayInSelectedRange': {
      backgroundColor: 'rgba(202, 202, 252, 0.15)',
    },
    '& .firstDayFromRange': {
      borderTopLeftRadius: '50%',
      borderBottomLeftRadius: '50%',
    },
    '& .lastDayFromRange': {
      borderTopRightRadius: '50%',
      borderBottomRightRadius: '50%',
    },
    '& .MuiOutlinedInput-adornedEnd': {
      paddingRight: '0',
    },

    //V5
    '& .css-bkrceb-MuiButtonBase-root-MuiPickersDay-root': {
      backgroundColor: 'unset',
    },
    '& .css-bkrceb-MuiButtonBase-root-MuiPickersDay-root.Mui-selected': {
      backgroundColor: '#3C419A',
    },
    '& .MuiPickersDay-dayOutsideMonth': {
      backgroundColor: 'unset',
    },
    '& .MuiClock-pin': {
      backgroundColor: '#3f51b5',
    },
    '& .MuiClockPointer-root': {
      backgroundColor: '#3f51b5',
    },
    '& .MuiClockPointer-thumb': {
      backgroundColor: '#3f51b5',
      borderColor: '#3f51b5',
    },
  },
}));
